import React from 'react';
import { Button, Paper, Typography, Box } from '@mui/material';
import { 
  CheckCircle as CheckCircleIcon,
  RadioButtonUnchecked as UncheckedIcon,
  ChevronRight as ChevronRightIcon,
  Edit as EditIcon
} from '@mui/icons-material';

const FormItemRow = ({ item, navigate }) => {
  const getStatusIcon = () => {
    switch(item.status) {
      case 'complete':
        return <CheckCircleIcon sx={{ color: '#4caf50', fontSize: 20 }} />;
      case 'incomplete':
        return <EditIcon sx={{ color: '#ff9800', fontSize: 20 }} />;
      default:
        return <UncheckedIcon sx={{ color: '#bdbdbd', fontSize: 20 }} />;
    }
  };

  const getStatusText = () => {
    switch(item.status) {
      case 'complete': return 'Completed - Click to Edit';
      case 'incomplete': return 'In Progress - Continue';
      default: return 'Not Started';
    }
  };

  const getColors = () => {
    switch(item.status) {
      case 'complete': return { bg: '#e8f5e9', border: '#a5d6a7', text: '#2e7d32' };
      case 'incomplete': return { bg: '#fff3e0', border: '#ffcc80', text: '#ef6c00' };
      default: return { bg: '#f1f8f9', border: '#b2dfdb', text: '#00695c' };
    }
  };

  const colors = getColors();

  return (
    <Button
      fullWidth
      onClick={() => navigate(item.url)}
      sx={{
        justifyContent: 'space-between',
        padding: '16px 20px',
        backgroundColor: colors.bg,
        border: `1px solid ${colors.border}`,
        borderRadius: '12px',
        marginBottom: '12px',
        textAlign: 'left',
        transition: 'all 0.2s',
        '&:hover': {
          backgroundColor: colors.bg,
          transform: 'translateY(-2px)',
          boxShadow: '0 4px 12px rgba(0,0,0,0.05)'
        },
        textTransform: 'none'
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Box sx={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <item.icon sx={{ color: colors.text, fontSize: 28 }} />
          <Box sx={{ position: 'absolute', top: -8, right: -8, backgroundColor: 'white', borderRadius: '50%', display: 'flex' }}>
            {getStatusIcon()}
          </Box>
        </Box>
        <Box>
          <Typography variant="subtitle1" sx={{ fontWeight: 600, color: colors.text, lineHeight: 1.2 }}>
            {item.title}
          </Typography>
          <Typography variant="caption" sx={{ color: colors.text, opacity: 0.8, display: 'block' }}>
            {item.description}
          </Typography>
          <Typography variant="caption" sx={{ fontWeight: 500, color: colors.text, mt: 0.5, display: 'block', fontSize: '0.7rem' }}>
            {getStatusText()}
          </Typography>
        </Box>
      </Box>
      <ChevronRightIcon sx={{ color: colors.text }} />
    </Button>
  );
};

export default FormItemRow;
